<template>
    <ul class="specs clearfix"
      style=" width:100%;height:100%;overflow:auto;">
    <li v-for="(type,index) in newsData"
        @click="newShowContent(index)"
        style="width:100%;"
        :key="index">
      <a href="javascript:;"
          style="width:100%;display:flex;justify-content:space-between">
        <!-- <span :class="['attribute-l',inds==index?'curr':'']" -->
        <span :class="['attribute-l']"
              style="width:65%">{{type.name}}</span>
        <!-- <span :class="['attribute-r',inds==index?'curr':'']" -->
        <span :class="['attribute-r']"
              style="width:30%;text-align:right;">{{type.time}}</span>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name:'jinrizixun',
  components:{
  },
  props:{
    sortTag:Array
  },
  data(){
    return{
      newsData:[],
      inds:0
    }
  },
  mounted(){
    this.getTagsTypeToday(this.sortTag);
  },
  computed:{
  },
  methods:{
    //展示今日资讯
    newShowContent (ind) {
      this.$emit('sendImageText',this.sortTag[ind]);
      // this.inds = ind;
    },
    //筛选文字信息
    getTagsTypeToday (list) {
      var alist = [], name, time,arr;
      if(list[0] instanceof Array){
        arr = list[0];
      }else{
        arr = list;
      }
      arr.map((ite, index) => {
        for (var i = 0; i < ite.length; i++) {
          if (ite[i].standardName == '文案标题') {
            name = ite[i].standardData;
          }
          if (ite[i].standardName == '发布日期') {
            time = ite[i].standardData;
          }
        }
        if (name || time)
          alist.push({
            name: name,
            time: time
          })
      })
      this.newsData = alist;
    }
  }
}
</script>
<style scoped>
.specs {
  font-size: 12px;
  color: #666;
  line-height: 28px;
  background-color:#fff;
}
.specs li {
  height: 36px;
  line-height: 36px;
  width: 100%;
  margin-right: 20px;
  overflow: hidden;
  font-size: 14px;
}
.curr {
  color: #0c78cf !important;
}
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/jinrizixun.vue